<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">SEND CLOA</span>
    </template>

    <v-card>
      <v-card-title>Send CLOA</v-card-title>

      <v-card-text>
        Are you sure you want to send a CLOA?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small :disabled="getSendCloaLoading" :loading="getSendCloaLoading" @click.prevent="submit({numberRangeId: item.id})">Send CLOA</v-btn>
        <v-btn color="primary" small outlined class="ml-3" :disabled="getSendCloaLoading" @click="dialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    item: {
      type: Object
    }
  },

  data() {
    return {
      dialog: false,
    }
  },

  computed: {
    ...mapGetters("numbers", ["getSendCloaLoading", "getSendCloaError"]),
  },

  methods: {
    ...mapActions("numbers", ["sendCloa"]),

    async submit(data) {
      try {
        await this.sendCloa(data);
        this.dialog = false;
      } catch(err) {
        return err;
      }
    },
  },
}
</script>

<style>
</style>
